
import { computed, defineComponent, PropType, watch } from "vue";
import { SupplyTaskStatus } from "@/model/CleanTaskingInfo";
import { fromatDateYMDHMS } from "@/utils/MyUtils";
import ConstantsType from "@/constant/ConstantsType";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "ReStart",
  emits: ["taskStatus"],
  props: {
    supply_task_status: {
      type: Object as PropType<SupplyTaskStatus>,
      required: true,
      defualt: {},
    },
  },
  setup(props, context) {
    const { t } = useI18n();
    const supplyTaskStatus = computed<SupplyTaskStatus>(
      () => props.supply_task_status
    );

    watch(supplyTaskStatus, () => {
      context.emit("taskStatus", supplyTaskStatus.value?.task_status);
    });

    return { supplyTaskStatus, fromatDateYMDHMS, ConstantsType, t };
  },
});
